import React from 'react';
import Popup from '../common/components/Popup';
import '../../assests/css/addcategory.scss';


interface deleteCategoryProps {
    showPopup: boolean,
    setShowPopup: (value: boolean) => void,
    deleteCategory: () => void,
}

function DeleteCategory(props: deleteCategoryProps) {
    const {showPopup, setShowPopup, deleteCategory} = props;
 
    return (
        <Popup
            show={showPopup}
            onClose={() => setShowPopup(false)}
            title='Are you sure you want to delete this category?'
            size='lg'
            primaryCtaText='Confirm Delete'
            primaryCtaOnClick={deleteCategory}
            secondaryCtaText='Cancel'
            secondaryCtaOnClick={() => setShowPopup(false)}
            customClassName='add-category-popup'
        />
    );
}

export default DeleteCategory;
